export function formatViews(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)} 万`;
  }
  return String(value);
}

export function formatDate(value: string): string {
  const [year, month, day] = value.split("-");
  return `${year} 年 ${Number(month)} 月 ${Number(day)} 日`;
}

export function shortDate(value: string): string {
  const [, month, day] = value.split("-");
  return `${Number(month)}-${Number(day)}`;
}

export function daysAgo(value: string): number {
  const target = new Date(`${value}T00:00:00`);
  const today = new Date("2026-10-17T00:00:00");
  return Math.floor((today.getTime() - target.getTime()) / 86400000);
}

export function withinDays(value: string, range: string): boolean {
  if (range === "all") return true;
  return daysAgo(value) <= Number(range);
}